var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('Header'),_c('Carousel',{attrs:{"carousel":[
    require("../assets/carousel/1.jpg"),
    require("../assets/carousel/2.jpg"),
    require("../assets/carousel/3.jpg"),
    require("../assets/carousel/4.jpg"),
    require("../assets/carousel/5.jpg")
  ]}})],1),_c('el-main',[_vm._t("default")],2),_c('el-footer',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }